import React from 'react';
import {routerConfig} from 'utils/routerConfig';
import EmptyPage from 'components/EmptyPage';
//503 验证

const wrapAuth = (ComposedComponent, account, path) => class WrapComponent extends React.Component {
    // 构造
    constructor(props) {
        super(props);
        this.state = {
            is503: false,
            is404: false,
            hasCheck: true
        };
        if(account.id){
            this.hasPermission = true;
        }
        //权限检测
        const _router = routerConfig[path] || {};
        const permission = _router['permission'];
        let intersection;
        if(permission){
            intersection = account.permissions.filter(v => permission.includes(v));
            this.hasPermission = intersection.length>0?true:false;
        }
    }

    render() {
        //无权限
        if(!this.hasPermission){
            return <div style={{marginTop:20}}><EmptyPage title='Sorry, you do not have permission to access this page' /></div>;
        }
        return <ComposedComponent  { ...this.props} />;
    }
};
export default wrapAuth;



// WEBPACK FOOTER //
// ./src/pages/WrapAuth.js